import { SurveyActions } from '@r1-frontend/survey/context/constants/actions';
import { SurveyButton } from '@r1-frontend/survey/context/surveys';

import { IAction } from '@r1-frontend/shared/types/Redux';

const setSurveyButton = (surveyButton?: SurveyButton): IAction<SurveyActions.SetSurveyButton, { surveyButton?: SurveyButton }> => ({
    type: SurveyActions.SetSurveyButton,
    payload: {
        surveyButton,
    },
});

export default setSurveyButton;
